<template>
  <div id="app" :class="{ header: hasHeader }">
    <keep-alive>
      <router-view v-if="!this.$route.meta.noKeepAlive" :key="key" />
    </keep-alive>
    <router-view v-if="this.$route.meta.noKeepAlive" :key="key" />
  </div>
</template>

<script>
import { hasHeader } from '@/components/app'
import { AppMixin } from '../common'

export default {
  name: 'App',
  mixins: [AppMixin],
  components: {},
  data() {
    return {
      hasHeader: hasHeader()
    }
  },
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {}
}
</script>

<style lang="less">
@import '../../less/styles.less';
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  font-size: 16px;
}
.mint-msgbox {
  .mint-msgbox-title {
    line-height: 1.5em !important;
    padding: 0px 20px 0px;
  }
}
</style>
<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Regular, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100% !important;
}
</style>
